import { CommonService } from "./common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "./api.service";
var VectorComponent = (function () {
    function VectorComponent(apiService, commonService, route, router) {
        this.apiService = apiService;
        this.commonService = commonService;
        this.route = route;
        this.router = router;
        this.learningDirect = false;
        this.learningPathMetaId = 0;
        this.assetsRoute = "../assets";
    }
    VectorComponent.prototype.onPopState = function () {
        $('#cards').unbind("touchstart");
        $('#cards').unbind("touchmove");
        $('#cards').unbind("touchend");
    };
    VectorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        if (sessionStorage.getItem("CID") == "2") {
            this.learningDirect = true;
        }
        console.log('34b5a2cd2471dbdcf03116746bb6ee81_3');
        var that = this;
        this.defaultAnswer = ["以理服人是我的影响风格。", "我喜欢用数据说话，让别人不得不服。",
            "我喜欢碎碎念，念到别人答应为止。",
            "我相信榜样的力量，身先士卒影响他人一起行动。",
            "我的热情就像一把火，影响的可不只是沙漠。",
            "思如泉涌的我总能得到别人的认同。",
            "咬定青山不放松，坚韧的我没有影响不了的人。"
        ];
        this.sub = this.route.params.subscribe(function (params) {
            _this.learningPathId = params['learningPathId'];
            _this.apiService.ajax({
                'type': 'get',
                'url': '/api/learningpathes/' + _this.learningPathId
            }).subscribe(function (result) {
                _this.learningPath = result;
            });
        });
        this.apiService.ajax({
            'type': 'get',
            'url': '/sr/learningtour',
        }).subscribe(function (result) {
            _this.learningTour = result.pre_survey_meta_ids.length > 0 ? true : false;
            _this.learningPathMetas = result.learning_path_metas;
        });
        var vid;
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/concatenation/' + this.learningPathId,
            'data': {
                'learningPathId': this.learningPathId,
            }
        }).subscribe(function (comment) {
            _this.chuanjie = comment[0].comment;
        });
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/learningpathes/' + this.learningPathId
        }).subscribe(function (result) {
            _this.learningPath = result;
            if (_this.learningPath.name == "辅导") {
                _this.apiService.ajax({
                    'type': 'get',
                    'url': '/sr/onceino/105',
                    'data': {}
                }).subscribe(function (result) {
                    _this.vectorStatus = result == 1 ? false : true;
                });
            }
            else if (_this.learningPath.name == "打造高效团队") {
                _this.apiService.ajax({
                    'type': 'get',
                    'url': '/sr/onceino/115',
                    'data': {}
                }).subscribe(function (result) {
                    _this.vectorStatus = result == 1 ? false : true;
                });
            }
            else if (_this.learningPath.name == "授权") {
                _this.apiService.ajax({
                    'type': 'get',
                    'url': '/sr/onceino/125',
                    'data': {}
                }).subscribe(function (result) {
                    _this.vectorStatus = result == 1 ? false : true;
                });
                vid = '34b5a2cd2446619931a77c3faa417888_3';
            }
            else if (_this.learningPath.name == "领导力精要") {
                _this.apiService.ajax({
                    'type': 'get',
                    'url': '/sr/onceino/135',
                    'data': {}
                }).subscribe(function (result) {
                    _this.vectorStatus = result == 1 ? false : true;
                });
                vid = '34b5a2cd245a02ebbad04cb7e4503d10_3';
            }
            else if (_this.learningPath.name == "计划与组织") {
                _this.apiService.ajax({
                    'type': 'get',
                    'url': '/sr/onceino/145',
                    'data': {}
                }).subscribe(function (result) {
                    _this.vectorStatus = result == 1 ? false : true;
                });
                vid = '34b5a2cd247f397e3522446121b4823c_3';
            }
            else if (_this.learningPath.name == "协作") {
                _this.apiService.ajax({
                    'type': 'get',
                    'url': '/sr/onceino/155',
                    'data': {}
                }).subscribe(function (result) {
                    _this.vectorStatus = result == 1 ? false : true;
                });
                vid = '34b5a2cd2489d2edf9bbbf6a3cc68fcf_3';
            }
            else if (_this.learningPath.name == "影响力" || _this.learningPath.name == "影响力专业版") {
                _this.apiService.ajax({
                    'type': 'get',
                    'url': '/sr/onceino/165',
                    'data': {}
                }).subscribe(function (result) {
                    _this.vectorStatus = result == 1 ? false : true;
                });
                vid = '34b5a2cd2471dbdcf03116746bb6ee81_3';
            }
            else if (_this.learningPath.name == "决策") {
                _this.apiService.ajax({
                    'type': 'get',
                    'url': '/sr/onceino/175',
                    'data': {}
                }).subscribe(function (result) {
                    _this.vectorStatus = result == 1 ? false : true;
                });
                vid = '34b5a2cd24b4c63de7f56261ac52b210_3';
            }
            var height = window.screen.width / 16 * 9;
            var player = polyvPlayer({
                wrap: '#video-vector',
                width: '100vw',
                height: height,
                vid: vid,
                watchStartTime: 0,
                ban_seek_by_limit_time: "on",
                autoplay: 0,
                // skinLocation: 0,
                // hideSwitchPlayer: true,
                hideRepeat: true,
                forceH5: true,
            });
            player.toggleFullscreen();
        });
        window['s2j_onPlayOver'] = function () {
            // if(that.vectorStatus){
            //   $("#shade").fadeIn();
            //   $("#guide").show();
            //   $("#guide").animate({
            //     'top':'0.9rem'
            //   });
            //   that.apiService.ajax({
            //     'type': 'get',
            //     'url':'/api/learningpathes/'+that.learningPathId
            //   }).subscribe(result=>{
            //    that.learningPath = result;
            //    that.apiService.ajax({
            //       'type':'post',
            //       'url':'/api/learningpathes/'+that.learningPathId+'/guideShown'
            //    }).subscribe(result=>{});
            //  });
            // }else{
            //   that.guideAnimateOut();
            // }
            if (that.learningPath.name == "影响力" || that.learningPath.name == "影响力专业版") {
                if (that.learningPath.subItems[0].progress == 100) {
                    that.answer = JSON.parse(that.learningPath.subItems[0].answer);
                    that.closeSlideEvent();
                    $('#head_wrap').hide();
                    $('#wrap').hide();
                    $('.card').hide();
                    $('.cardFront').hide();
                    $('#title2Before').hide();
                    $('#title2After').show();
                    $('#card' + that.answer.choice).show();
                    $('#cardBack' + that.answer.choice).show();
                    $('#textEnterAfter' + that.answer.choice).text(that.answer.text);
                    $('#wrapVector').show(function () {
                        that.currentNumber = that.answer.choice + 1;
                        that.setCardsPosition(1);
                    });
                }
                else {
                    $('#head_wrap').hide();
                    $('#wrap').hide();
                    $('#wrapVector').show(function () {
                        that.initSlideEvent();
                        that.currentNumber = 1;
                        that.setCardsPosition(0);
                    });
                }
            }
            else {
                that.apiService.ajax({
                    'type': 'post',
                    'url': '/api/learningpathes/' + that.learningPathId + '/guideShown'
                }).subscribe(function (result) {
                    $("#shade").fadeIn();
                    $("#guide").show();
                    $("#guide").animate({
                        'top': '0.9rem'
                    });
                });
            }
        };
    };
    VectorComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    VectorComponent.prototype.guideAnimateOut = function () {
        var _this = this;
        if (this.learningTour) {
            this.apiService.ajax({
                'type': 'get',
                'url': '/api/learningpathes/' + this.learningPathId
            }).subscribe(function (result) {
                _this.learningPath = result;
                var courseId, itemIndex;
                _this.learningPath.subItems.forEach(function (item, index) {
                    if (item.type == 2) {
                        courseId = item.id;
                        itemIndex = index;
                    }
                });
                _this.apiService.ajax({
                    'type': 'GET',
                    'url': '/sr/exposeoutapi/setAbilitySession/' + _this.learningPathMetaId + '/2'
                }).subscribe(function (result) { });
                var link = ['course', _this.learningPath.id, courseId];
                _this.router.navigate(link);
            });
        }
        else {
            this.apiService.ajax({
                'type': 'get',
                'url': '/api/learningpathes/' + this.learningPathId
            }).subscribe(function (result) {
                _this.learningPath = result;
                var surveyMetaId, courseId, itemIndex;
                if (_this.learningPath.name != "领导力精要" && !_this.learningDirect) {
                    /* 进入新能力诊断标识 */
                    var version_1 = 0;
                    _this.learningPath.subItems.forEach(function (item, index) {
                        if (item.type == 1) {
                            surveyMetaId = item.surveyMetaId;
                            itemIndex = index;
                            if (item.version) {
                                version_1 = item.version;
                            }
                        }
                    });
                    var tempThat_1 = _this;
                    _this.learningPathMetas.forEach(function (item, i) {
                        if (item.name == result.name) {
                            tempThat_1.learningPathMetaId = item.id;
                        }
                    });
                    _this.apiService.ajax({
                        'type': 'GET',
                        'url': '/sr/exposeoutapi/setAbilitySession/' + _this.learningPathMetaId + '/1'
                    }).subscribe(function (result) { });
                    var link = ['ability-survey', _this.learningPathMetaId, 1];
                    // let link = ['survey', this.learningPath.id, surveyMetaId, 1];
                    // if(version == 1){
                    // 	link = ['ability-survey', this.learningPathMetaId, 1]
                    // }
                    _this.router.navigate(link);
                }
                else {
                    _this.learningPath.subItems.forEach(function (item, index) {
                        if (item.type == 2) {
                            courseId = item.id;
                            itemIndex = index;
                        }
                    });
                    var link = ['course', _this.learningPath.id, courseId];
                    _this.router.navigate(link);
                }
            });
        }
    };
    // 关闭回到学习路径
    VectorComponent.prototype.close = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
        }).subscribe(function (result) {
            var link = ['learning-path', result.data];
            _this.router.navigate(link);
        });
        $('#cards').unbind("touchstart");
        $('#cards').unbind("touchmove");
        $('#cards').unbind("touchend");
        // let link = ['learning-path', ];
        // this.router.navigate(link);
    };
    VectorComponent.prototype.closeCard = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
        }).subscribe(function (result) {
            var link = ['learning-path', result.data];
            _this.router.navigate(link);
        });
    };
    VectorComponent.prototype.initSlideEvent = function () {
        var startX, startY, moveEndX, moveEndY, X, Y;
        var _this = this;
        $('#cards').unbind("touchstart");
        $('#cards').unbind("touchmove");
        $('#cards').unbind("touchend");
        $("#cards").on("touchstart", function (e) {
            startX = e.originalEvent.changedTouches[0].pageX;
            startY = e.originalEvent.changedTouches[0].pageY;
        });
        $("#cards").on("touchmove", function (e) {
            moveEndX = e.originalEvent.changedTouches[0].pageX;
            moveEndY = e.originalEvent.changedTouches[0].pageY;
            X = moveEndX - startX;
            Y = moveEndY - startY;
            var w = X < 0 ? X * -1 : X; //x轴的滑动值
            var h = Y < 0 ? Y * -1 : Y; //y轴的滑动值
        });
        $("#cards").on("touchend", function (e) {
            moveEndX = e.originalEvent.changedTouches[0].pageX;
            moveEndY = e.originalEvent.changedTouches[0].pageY;
            X = moveEndX - startX;
            Y = moveEndY - startY;
            var w = X < 0 ? X * -1 : X; //x轴的滑动值
            var h = Y < 0 ? Y * -1 : Y; //y轴的滑动值
            if (X > 5 && w > h) {
                _this.slide('right');
            }
            else if (X < -5 && w > h) {
                _this.slide('left');
            }
        });
    };
    VectorComponent.prototype.closeSlideEvent = function () {
        $('#cards').unbind("touchstart");
        $('#cards').unbind("touchmove");
        $('#cards').unbind("touchend");
    };
    VectorComponent.prototype.slide = function (direction) {
        console.log("slide");
        if (direction == 'left' && this.currentNumber <= 7) {
            this.currentNumber += 1;
            this.setCardsPosition(1);
        }
        else if (direction == 'right' && this.currentNumber > 1) {
            this.currentNumber = this.currentNumber == 1 ? 1 : this.currentNumber - 1;
            this.setCardsPosition(1);
        }
    };
    VectorComponent.prototype.setCardsPosition = function (status) {
        var active = this.currentNumber - 1;
        if (status == 0) {
            $('#card0').addClass('active');
        }
        else if (status == 1) {
            $('.card.active').removeClass('active');
            $(('#card' + active)).addClass('active');
        }
    };
    VectorComponent.prototype.onVectorSubmit = function (i) {
        var _this = this;
        var ajaxAnswer = $('#textEnter' + i).val(), ajaxChoice = i;
        console.log(this.learningPath.subItems[0].guide.id);
        if ((!ajaxAnswer || ajaxAnswer == "") && i == 7) {
            $('#shade3').fadeIn(200, function () {
                setTimeout(function () {
                    $('#shade3').fadeOut(200);
                }, 1000);
            });
            return;
        }
        else if ((!ajaxAnswer || ajaxAnswer == "") && i != 7) {
            ajaxAnswer = this.defaultAnswer[i];
        }
        this.closeSlideEvent();
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/learningpathes/' + this.learningPathId + '/guideAnswer',
            'data': {
                'guideId': this.learningPath.subItems[0].guide.id,
                'answer': {
                    'choice': ajaxChoice,
                    'text': ajaxAnswer
                }
            }
        }).subscribe(function (result) {
            _this.apiService.ajax({
                'type': 'post',
                'url': '/api/learningpathes/' + _this.learningPathId + '/guideShown'
            }).subscribe(function (result2) {
                $('#head_wrap').hide();
                $('#wrap').hide();
                $('.card').hide();
                $('.cardFront').hide();
                $('#title2Before').hide();
                $('#title2After').show();
                $('#card' + i).show();
                $('#card' + i).find('.cardBack').show();
                $('#textEnterAfter' + i).text(ajaxAnswer);
                $('#wrapVector').show();
            });
        });
    };
    VectorComponent.prototype.onVectorClose = function () {
        $("#shade").fadeIn();
        $("#guide").show();
        $("#guide").animate({
            'top': '0.9rem'
        });
    };
    VectorComponent.prototype.onTextEnter = function (event, i) {
        var enterString = $('#textEnter' + i).val();
        // let enterString = $('#textEnter' + i).val().replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDE80-\uDEFF]/g,'');
        $('#textEnter' + i).val(enterString);
    };
    VectorComponent.prototype.goToTop = function () {
        window.scrollTo(0, 0);
    };
    return VectorComponent;
}());
export { VectorComponent };



// WEBPACK FOOTER //
// ./src/app/vector.component.ts.pre-build-optimizer.js